<template>
  <v-card class="pa-5" elevation="1">
    <v-card-title class="px-0 pt-0">Saldo a receber</v-card-title>

    <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-4" />

    <template v-else-if="balance || recipient">
      <Tabs v-model="tab" @setTab="setTab">
        <Tab v-for="item in tabItems" :key="item">{{ item }}</Tab>
      </Tabs>

      <TabsItems v-model="tab" class="mt-4">
        <component
          :is="componentTabItem"
          :balance="balance"
          :recipient="recipient"
        />
      </TabsItems>
    </template>

    <div v-else class="text-center py-6">
      Não foi possível carregar os seus dados de recebimento.
    </div>
  </v-card>
</template>

<script>
import { Tabs, Tab, TabsItems } from '@/components/vuetify';
import AdminDistributorPagarmeBalanceTab from './components/AdminDistributorPagarmeBalanceTab.vue';
import AdminDistributorPagarmeRecipientTab from './components/AdminDistributorPagarmeRecipientTab.vue';

const TAB_COMPONENTS = [
  AdminDistributorPagarmeBalanceTab,
  AdminDistributorPagarmeRecipientTab,
];

export default {
  name: 'AdminMyRecipientDetails',
  components: {
    Tabs,
    Tab,
    TabsItems,
  },
  data() {
    return {
      loading: false,
      balance: null,
      recipient: null,
      tab: 0,
      tabItems: ['Saldo', 'Recebedor'],
      componentTabItem: AdminDistributorPagarmeBalanceTab,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    setTab(tab) {
      this.tab = tab;
      this.componentTabItem = TAB_COMPONENTS[tab];
    },
    fetchData() {
      this.loading = true;
      this.$api.admin
        .getMyRecipientDetails()
        .then(({ data }) => {
          this.balance = data.balance || null;
          this.recipient = data.recipient || null;
        })
        .catch((err) => {
          const message = err.response?.data?.error || 'Erro ao carregar os seus dados de recebimento';
          this.$noty.error(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
